import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import BasicButton from '@/ui-components/BasicButton.vue';
import InputAvatar from '@/features/ui/components/InputAvatar.vue';
import InputSelect from '@/features/ui/components/InputSelect.vue';
import InputText from '@/features/ui/components/InputText.vue';
import InputTextArea from '@/features/ui/components/InputTextArea.vue';

import { useI18n } from '@/helpers/composables/useI18n';
import { useUserProfileEdit } from '@/features/user-profile/composables/useUserProfileEdit';
import { useLanguageStore, useUserStore } from '@/helpers/composables/useStores';
import { toastError, toastSuccess } from '@/helpers/toast/toast-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateUserProfileModal',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
	(e: 'close', display: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const BaseModalNew = () => import('@/components/modals/BaseModalNew.vue');



const { t, tc } = useI18n();

const { profileData, submitProfile, countries, loading, onError, onDone } = useUserProfileEdit();
const { profileInfo } = useUserStore();
const { country } = useLanguageStore();

const prefilledCountry = ref(countries.find(c => c.value === country.value) || { item: '', value: '' });

const prefilledCountryValue = computed({
	get: () => prefilledCountry.value.value,
	set: newValue => {
		const country = countries.find(c => c.value === newValue);
		if (country) prefilledCountry.value = country;
	},
});

const page = ref(1);
const isSubmitting = ref(false);

const page1Validation = computed(() => {
	return !!(
		profileData.firstName &&
		profileData.lastName &&
		profileData.country &&
		(profileData.avatarBase64 || profileInfo.value?.avatarUrl)
	);
});

const page2Validation = computed(() => !!profileData.bio);

const submitValidation = computed(() => page1Validation.value && page2Validation.value);

const buttonText = computed(() => {
	switch (page.value) {
		case 3:
			return tc('WEBAPP_CREATE_PROFILE');
		default:
			return t('WEBAPP_NEXT');
	}
});

const isButtonDisabled = computed(() => {
	switch (page.value) {
		case 1:
			return !page1Validation.value || loading.value || isSubmitting.value;
		case 2:
			return !page2Validation.value || loading.value || isSubmitting.value;
		case 3:
			return !submitValidation.value || loading.value || isSubmitting.value;
		default:
			return true;
	}
});

function handleButtonClick() {
	isSubmitting.value = true;

	submitProfile();

	onError(error => {
		isSubmitting.value = false;

		toastError({
			message: error.message,
		});
	});

	onDone(() => {
		isSubmitting.value = false;
	});

	if (page.value === 1 || page.value === 2) {
		page.value++;
	} else if (page.value === 3) {
		emit('close', true);

		toastSuccess({
			message: 'Profile created successfully',
		});
	}
}

function handleAvatarBase64(base64: string) {
	profileData.avatarBase64 = base64;
}

function handlePreviousClick() {
	if (page.value > 1) page.value--;
}

return { __sfc: true,BaseModalNew, emit, t, tc, profileData, submitProfile, countries, loading, onError, onDone, profileInfo, country, prefilledCountry, prefilledCountryValue, page, isSubmitting, page1Validation, page2Validation, submitValidation, buttonText, isButtonDisabled, handleButtonClick, handleAvatarBase64, handlePreviousClick, BasicButton, InputAvatar, InputSelect, InputText, InputTextArea }
}

})